export default {
    namespaced: true,
    state: {
        bot: null,
        profile: null
    },
    actions: {
    },
    getters: {
    },
    mutations: {
        /**
         * {name: 'properties', val: 'value'}
         * @param state
         * @param name
         * @param val
         * @private
         */
        __set(state, {name, val}) {
            state[name] = val
            const data = {}
            for (let i in state) {
                if (i === 'token') {
                    continue
                }
                data[i] = state[i]
            }
        },
        setBotSettings(state, settings) {
            state.bot.settings = settings
        },
        setBotIgnore(state, {ignore, ignore_all_outgoing}) {
            if (!state.bot.settings) {
                state.bot.settings = {}
            }
            state.bot.settings.ignore = ignore
            state.bot.settings.ignore_all_outgoing = ignore_all_outgoing
        },
        setBotConnectedResources(state, connected_resources) {
            if (!state.bot.settings) {
                state.bot.settings = {}
            }
            state.bot.settings.connected_resources = connected_resources
        },
        setBotEventsMap(state, events_map) {
            if (!state.bot.settings) {
                state.bot.settings = {}
            }
            state.bot.settings.events_map = events_map
        },
        setFakeCommand(state, command) {
            state.bot.fakeCommand = command
        },
        setHasToken(state, val) {
            state.bot.has_token = val
        }
    }

}

